<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-header>
        <span style="margin-left: 0px;margin-top:20px;"  class="lanai-page-title">spACE Email Address</span>
      </mat-card-header>    
    <mat-card-content>
        <ng-container *ngIf="resendEmailMode === false">
            <form 
            (ngSubmit)="onSubmitAddNewSpaceEmail()" 
            novalidate
            [formGroup]="emailSpaceForm" >
                <div class="row margin-top:20px;">
                    <div class="col-4">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>spACE Email Address</mat-label>
                            <input matInput placeholder="spACE Email Address" autocomplete="chrome-off" formControlName="emailAddress">
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary mt-3" style="margin-left:5px;" [disabled]="isCompanyPaid">Add Space Email</button>
            </form>
        </ng-container>

        <ng-container *ngIf="resendEmailMode">
            <form 
            (ngSubmit)="onSubmitResendSpaceEmail()" 
            novalidate
            [formGroup]="resendEmailForm" >
                <div class="row margin-top:20px;">
                    <div class="col-4">
                        <!-- <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>spACE Email Address</mat-label>
                            <input matInput placeholder="spACE Email Address" autocomplete="chrome-off" readonly="true" formControlName="emailAddress"    (keydown)="onKeyDown($event)">
                        </mat-form-field> -->
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>spACE Email Address</mat-label>
                            <input matInput placeholder="spACE Email Address" autocomplete="chrome-off" readonly="true" formControlName="emailAddress"    (keydown)="onKeyDown($event)">
                            <mat-icon matSuffix class="mimic-button-hover"  aria-label="Copy spACE Email Address" [cdkCopyToClipboard]="spaceEmailValue"  matTooltip="Copy spACE Email Address" (click)="onCopyMessage('The spACE Email Address has been copied to the clipboard')">content_copy</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-2">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Original Email Date</mat-label>
                            <input matInput placeholder="Original Email Date" autocomplete="chrome-off" readonly="true" formControlName="dateLastModified">
                        </mat-form-field>
                    </div>
                    <div class="col-2">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Resent Email Date</mat-label>
                            <input matInput placeholder="Resent Email Date" autocomplete="chrome-off" readonly="true" formControlName="dateEmailResent">
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary mt-3" style="margin-left:5px;" [disabled]="isCompanyPaid">Resend Space Email</button>
            </form>
        </ng-container>
    </mat-card-content>
    <mat-card-actions style="margin-top:20px;">
    <div *ngIf="isCompanyPaid" style="margin-left:20px;">
        <span style="font-size:18px;font-weight: bold;">This is a company paid Parker Profile.  Emails cannot be added to company paid Parker Profiles.</span>
    </div>
    </mat-card-actions>
</mat-card>

